type HomeLayoutProps = {
   children: React.ReactNode
   className?: string
}

export const HomeLayout = ({ children, className }: HomeLayoutProps) => {
   return <section className={`mt-16 ${className}`}>{children}</section>
}
// figd_WznCw46-Vimb-_XExGheRIFHOKJU9NTG9-sud5Yx
